module.exports = __webpack_public_path__ + "img/MOVIE_THEATER.eb67b5eb.png";